import type { FC } from 'react'
import { ToggleButton as MuiToggleButton, type ToggleButtonProps as MuiToggleButtonProps } from '@mui/material'

/**
 * The MUI ToggleButton with `color`, `size`, and `disableRipple` taken out.
 *
 * The theme already sets these, so passing them does nothing.
 * Hiding them from the type just stops us doing it by accident.
 */
type ToggleButtonProps = Omit<MuiToggleButtonProps, 'color' | 'size' | 'disableRipple'>

export const ToggleButton: FC<ToggleButtonProps> = MuiToggleButton
